import { z } from "zod";
/**
 * Invite friends, earn PRO. Every account has its own code; a friend uses it
 * at sign-up (typed in, or carried by /register?ref=CODE). Two ladders:
 * how many friends came (a friend counts once they have watched an hour —
 * so a pile of empty accounts earns nothing), and how many hours all of
 * them have watched together. Each step is taken with a button; PRO from
 * them stacks onto PRO running now and runs out on its own.
 */
export const REFERRAL = {
    /** A friend counts for the friends ladder after this much watching. */
    countAfterSeconds: 3600,
};
/**
 * What inviting friends earns: badges and the title — never PRO. PRO comes
 * only from the welcome gift and a purchase.
 */
export const REFERRAL_REWARDS = [
    { id: "f1", track: "friends", at: 1, badge: "referral-guide", label: "Значок «Проводник»" },
    { id: "f10", track: "friends", at: 10, badge: "referral-ambassador", label: "Значок «Посол»" },
    { id: "f25", track: "friends", at: 25, badge: "referral-legend", label: "Значок «Легенда»" },
    { id: "h20", track: "hours", at: 20, badge: "referral-spark", label: "Значок «Искра»" },
    { id: "h100", track: "hours", at: 100, title: true, label: "Своя приписка к нику — навсегда" },
    { id: "h500", track: "hours", at: 500, badge: "referral-star", label: "Значок «Звезда»" },
];
/** Codes are 8 characters from an alphabet without look-alikes. */
export const REFERRAL_CODE_ALPHABET = "ABCDEFGHJKMNPQRSTUVWXYZ23456789";
export const referralCodeSchema = z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z0-9]{4,12}$/, "Код — 8 латинских букв и цифр");
export const referralFriendSchema = z.object({
    id: z.string(),
    displayName: z.string(),
    username: z.string().nullable(),
    avatarUrl: z.string().nullable(),
    joinedAt: z.string(),
    hours: z.number(),
    /** Has watched enough to count for the friends ladder. */
    counted: z.boolean(),
});
export const referralRewardStateSchema = z.object({
    id: z.string(),
    track: z.enum(["friends", "hours"]),
    at: z.number(),
    proDays: z.number().nullable(),
    badge: z.string().nullable(),
    title: z.boolean(),
    label: z.string(),
    claimed: z.boolean(),
    /** Reached and not taken yet. */
    claimable: z.boolean(),
});
export const referralStateSchema = z.object({
    code: z.string(),
    /** total/counted include `bonus` — friends an admin added. */
    friends: z.object({ total: z.number(), counted: z.number(), bonus: z.number().default(0) }),
    /** All friends' watching together, in hours (one decimal). */
    hours: z.number(),
    rewards: z.array(referralRewardStateSchema),
    people: z.array(referralFriendSchema),
    /** The account's PRO now: until when (null = for good), or not PRO. */
    pro: z.object({ active: z.boolean(), until: z.string().nullable(), trialUntil: z.string().nullable() }),
    titleUnlocked: z.boolean(),
});
export const referralClaimInputSchema = z.object({ rewardId: z.string().min(1).max(10) });
//# sourceMappingURL=referral.js.map